import PropTypes from 'prop-types'

import CartIcon from '@/assets/templates/icons/cartIcon'
import StarIcon from '@/assets/templates/icons/starIcon'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './views'

const JewelryStore = () => {
  const { template } = useTemplateContext()

  return (
    <Layout.Container>
      {/* Layout.Header mapped to TemplateHeader with primary text */}
      <Layout.Header backgroundColor="#ffffff" textColor="primary" bottomBorderColor="complementary">
        <Layout.HeaderContent>
          <Layout.HeaderInfo>000-000-0000</Layout.HeaderInfo>
          <Layout.Title>{template.logo.text}</Layout.Title>
          <Layout.Menu>
            <Layout.HeaderInfo>Address</Layout.HeaderInfo>
            <Layout.Navigation textColor="primary">
              <CartIcon />
            </Layout.Navigation>
          </Layout.Menu>
        </Layout.HeaderContent>
      </Layout.Header>

      {/* Navigation with primary text */}
      <Layout.Navigation textColor="textPrimary">
        <Layout.Nav>
          <Layout.NavItem>Order</Layout.NavItem>
          <Layout.NavItem>Feature</Layout.NavItem>
          <Layout.NavItem>Gallery</Layout.NavItem>
          <Layout.NavItem>Contact Us</Layout.NavItem>
        </Layout.Nav>
      </Layout.Navigation>
      {/* Bar with primary text and white icons */}
      <Layout.Bar>
        <Layout.Navigation className="w-full h-full flex !justify-center" textColor="textSecondary" backgroundColor="primary">
          {template.sections.features?.map((feature, index) => (
            <Layout.NavItem key={index}>
              <StarIcon />
              {feature.title}
            </Layout.NavItem>
          ))}
        </Layout.Navigation>
      </Layout.Bar>

      <Layout.Content backgroundImage={template.sections.hero.backgroundImage}>        
        {/* Hero Card */}
        <Layout.Card>
          <div>
            <Layout.HeroSubtitle>{template.sections.hero.subtitle2}</Layout.HeroSubtitle>
            <Layout.HeroTitle>{template.sections.hero.title}</Layout.HeroTitle>
            <Layout.HeroDescription>{template.sections.hero.subtitle}</Layout.HeroDescription>
          </div>
          {/* CTA with primary text */}
          <Layout.CTA
            variant="text"
            textColor="primary" // Button text should be primary as per theme mapping
          >
            {template.sections.hero.ctaText} →
          </Layout.CTA>
        </Layout.Card>
      </Layout.Content>
    </Layout.Container>
  )
}

JewelryStore.propTypes = {
  config: PropTypes.object,
}
export default JewelryStore
